// Imported from source not the ~/components barrel. The map is built at module
// scope and the barrel re-exports this file, so barrel imports resolve undefined
import SafetyIcon75TonTruck from '~/components/svg/safetyIcons/safetyIcon75TonTruck'
import SafetyIconAngleLifting from '~/components/svg/safetyIcons/safetyIconAngleLifting'
import SafetyIconBreathableMask1 from '~/components/svg/safetyIcons/safetyIconBreathableMask1'
import SafetyIconBreathableMask2 from '~/components/svg/safetyIcons/safetyIconBreathableMask2'
import SafetyIconBreathableMask3 from '~/components/svg/safetyIcons/safetyIconBreathableMask3'
import SafetyIconDiesel from '~/components/svg/safetyIcons/safetyIconDiesel'
import SafetyIconDust from '~/components/svg/safetyIcons/safetyIconDust'
import SafetyIconEarDefenders from '~/components/svg/safetyIcons/safetyIconEarDefenders'
import SafetyIconEstateCar from '~/components/svg/safetyIcons/safetyIconEstateCar'
import SafetyIconEyeProtection from '~/components/svg/safetyIcons/safetyIconEyeProtection'
import SafetyIconHookSafety from '~/components/svg/safetyIcons/safetyIconHookSafety'
import SafetyIconPersonnelLifting from '~/components/svg/safetyIcons/safetyIconPersonnelLifting'
import SafetyIconPetrol from '~/components/svg/safetyIcons/safetyIconPetrol'
import SafetyIconPetrolRestriction from '~/components/svg/safetyIcons/safetyIconPetrolRestriction'
import SafetyIconPowerBreaker from '~/components/svg/safetyIcons/safetyIconPowerBreaker'
import SafetyIconProtectiveGloves from '~/components/svg/safetyIcons/safetyIconProtectiveGloves'
import SafetyIconSafetyFootwear from '~/components/svg/safetyIcons/safetyIconSafetyFootwear'
import SafetyIconSafetyHelmets from '~/components/svg/safetyIcons/safetyIconSafetyHelmets'
import SafetyIconShoesUinfo from '~/components/svg/safetyIcons/safetyIconShoesUinfo'
import SafetyIconSlingLifting from '~/components/svg/safetyIcons/safetyIconSlingLifting'
import SafetyIconTowable from '~/components/svg/safetyIcons/safetyIconTowable'
import SafetyIconTruck from '~/components/svg/safetyIcons/safetyIconTruck'
import SafetyIconVerticalLifting from '~/components/svg/safetyIcons/safetyIconVerticalLifting'
import SafetyIconVibrationCautionGreen from '~/components/svg/safetyIcons/safetyIconVibrationCautionGreen'
import SafetyIconVibrationCautionGreen1 from '~/components/svg/safetyIcons/safetyIconVibrationCautionGreen1'
import SafetyIconVibrationCautionRed from '~/components/svg/safetyIcons/safetyIconVibrationCautionRed'
import { normaliseSafetyIcon } from '~/utils'

// Types
import type { SafetyIconNames } from '~/types'
import type { ComponentType } from 'react'

interface SafetyIconEntry {
  Icon: ComponentType<{ className?: string }>
  text: string
}

// Keyed on the normalised slug so every variant Brenda sends hits one entry
const safetyIcons: Record<string, SafetyIconEntry> = {
  '75tontruck': {
    Icon: SafetyIcon75TonTruck,
    text: '7.5 Ton Truck',
  },
  anglelifting: {
    Icon: SafetyIconAngleLifting,
    text: 'Use at any angle for lifting, pulling or dragging. Anchor to a secure point able to take load force applied. Allow for contact friction if dragging.',
  },
  breathablemasks1: {
    Icon: SafetyIconBreathableMask1,
    text: 'General purpose, disposable masks for protection against low-risk dust and water-based airborne sprays.',
  },
  breathablemasks2: {
    Icon: SafetyIconBreathableMask2,
    text: 'Respiratory disposable masks with charcoal filter recommended to protect against welding fumes, ozone and most nuisance level odours.',
  },
  breathablemasks3: {
    Icon: SafetyIconBreathableMask3,
    text: 'Consult product supplier for guidance and COSHH data information',
  },
  diesel: {
    Icon: SafetyIconDiesel,
    text: 'We can supply red diesel, eco packs and fuel management services',
  },
  dust: {
    Icon: SafetyIconDust,
    text: 'We recommend using a Dust Extractor where you see this symbol',
  },
  eardefenders: {
    Icon: SafetyIconEarDefenders,
    text: 'Protection required against high noise levels. Earplugs are suitable for short-term work.',
  },
  estatecar: {
    Icon: SafetyIconEstateCar,
    text: 'You will need a vehicle at least the size of an estate car to collect this item.',
  },
  eyeprotection: {
    Icon: SafetyIconEyeProtection,
    text: 'You must wear all round protection grade 1 goggles to EN 166.B - for less hazardous work grade 2 spectacles can be worn.',
  },
  hooksafety: {
    Icon: SafetyIconHookSafety,
    text: 'Ensure safety catches are engaged and load chains/cables are untangled and hang freely.',
  },
  personnellifting: {
    Icon: SafetyIconPersonnelLifting,
    text: 'Equipment designed for personnel lifting. Use of safety restraint harness recommended.',
  },
  petrol: {
    Icon: SafetyIconPetrol,
    text: 'We are restricted by law from supplying petrol with our equipment, however an approved petrol container can be purchased at checkout.',
  },
  petrolrestriction: {
    Icon: SafetyIconPetrolRestriction,
    text: 'We are unable to supply petrol with our equipment due to licensing restrictions. However a petrol can, can be purchased at checkout.',
  },
  powerbreaker: {
    Icon: SafetyIconPowerBreaker,
    text: 'Residual Current Devices protect form electric shock. Strongly recommended for electrical equipment used outdoors or in damp conditions.',
  },
  protectivegloves: {
    Icon: SafetyIconProtectiveGloves,
    text: 'Gauntlets, PVC, cotton or rigger gloves are required with this item for hand protection.',
  },
  safetyfootwear: {
    Icon: SafetyIconSafetyFootwear,
    text: 'We recommend you wear steel toe protection when using this product.',
  },
  safetyhelmets: {
    Icon: SafetyIconSafetyHelmets,
    text: 'Protect against falling objects. Compulsory on site.',
  },
  shoesunifo: {
    Icon: SafetyIconShoesUinfo,
    text: 'You are required to wear safety footwear to BS EN 345 for tow protection with this item.',
  },
  slinglifting: {
    Icon: SafetyIconSlingLifting,
    text: 'Do not use load cable/chain as sling. Prevent hook overcrowding, with a bow shackle. Join lifting equipment with a D shackle. Protect sharp edges to prevent load damage.',
  },
  towable: {
    Icon: SafetyIconTowable,
    text: 'This item is towable, you need a vehicle that has a tow bar.',
  },
  truck: {
    Icon: SafetyIconTruck,
    text: 'You will need a vehicle at least the size of a truck to collect this item.',
  },
  verticallifting: {
    Icon: SafetyIconVerticalLifting,
    text: 'Use only for vertical lifts. Position or suspend equipment from a safe point to take weight of load and equipment.',
  },
  vibrationcautiongreen: {
    Icon: SafetyIconVibrationCautionGreen,
    text: 'Medium vibration risk - for tools that may be used for up to 2 hours before reaching vibration Exposure Limit Value (ELV)',
  },
  vibrationcautiongreen1: {
    Icon: SafetyIconVibrationCautionGreen1,
    text: 'This tool can be used intermittently for up to 8 hours before reaching Exposure Limit Value (ELV).',
  },
  vibrationcautionred: {
    Icon: SafetyIconVibrationCautionRed,
    text: 'High risk tool having more than 5m/s2.',
  },
}

// Main export
const SafetyIcon = ({ icon }: { icon: SafetyIconNames }) => {
  const match = safetyIcons[normaliseSafetyIcon(icon)]

  // Nothing is shown for an unmapped slug, so flag the gap outside production
  if (!match) {
    if (process.env.NODE_ENV !== 'production') {
      console.warn('[SafetyIcon] no entry for slug:', icon)
    }

    return null
  }

  const { Icon, text } = match

  return (
    <div className="mb-2 flex gap-4 font-semibold">
      <span aria-hidden="true">
        <Icon className="size-10 min-h-10 min-w-10" />
      </span>
      <p className="mb-0 pt-1">{text}</p>
    </div>
  )
}

export default SafetyIcon
